import { errorCodeToText } from '../../../../../clearance/error-code-to-text';

export const formatClearanceStatusCode = (
  clearanceStatusCode: string | null,
): string => {
  if (clearanceStatusCode === null) {
    return '-';
  }

  return errorCodeToText(clearanceStatusCode);
};
